import { render, staticRenderFns } from "./gerarBoleto.vue?vue&type=template&id=4b1cf3ca"
import script from "./gerarBoleto.ts?vue&type=script&lang=js&external"
export * from "./gerarBoleto.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1cf3ca')) {
      api.createRecord('4b1cf3ca', component.options)
    } else {
      api.reload('4b1cf3ca', component.options)
    }
    module.hot.accept("./gerarBoleto.vue?vue&type=template&id=4b1cf3ca", function () {
      api.rerender('4b1cf3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/financeiro/gerarBoleto.vue"
export default component.exports